import React, { ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { FrontPageState } from '../../../reducer';
import SectionErrorBoundary from './SectionErrorBoundary';

export default function StartPuffsSection(): ReactElement {
  const { startPuffs, isLoading } = useSelector((state: FrontPageState) => ({
    startPuffs: state.startPuffs,
    isLoading: state.isLoading.indexOf('start_puffs') !== -1,
  }));
  return (
    <SectionErrorBoundary name="StartPuffsSection" message="">
      <section id="start-puffs" className="start-section">
        <div className="section-title-container">
          <h2 className="section-title">
            <span className="section-title-text">Mer om oss</span>
          </h2>
        </div>
        <div className="section-content content-container start-puffs">
          {isLoading && (
            <div className="media-feed-loader">
              <div className="cssload-container">
                <ul className="cssload-flex-container">
                  <li>
                    <span className="cssload-loading" />
                  </li>
                </ul>
              </div>
            </div>
          )}
          {startPuffs.items.map((item) => (
            <div key={item.id} className="start-puff front-puff content-bg">
              <div className="start-puff-image disable-select" style={{ backgroundImage: `url('${item.image}')` }} />

              <div className="start-puff-content">
                <div className="start-puff-title">{item.label}</div>
                <div className="start-puff-text">
                  <p>{item.text}</p>
                </div>
              </div>
              <div className="start-puff-link">
                <a href={item.link} className="btn btn-default btn-feed">
                  {item.linkLabel}
                </a>
              </div>
            </div>
          ))}
        </div>
      </section>
    </SectionErrorBoundary>
  );
}
